import { marker as i18n } from '@biesbjerg/ngx-translate-extract-marker';

import type { ITrialFormFullOptions } from 'components/molecules/trial-form-v2/entities/types';

export type TTrialFormStrings = Pick<
    ITrialFormFullOptions,
    'inputLabelText' | 'inputPlaceholderText' | 'buttonSendText' | 'errorList' | 'googleButtonText'
>;

export const getTrialFormDefaultStrings = (): TTrialFormStrings => ({
    inputLabelText: i18n('Enter your business email'),
    inputPlaceholderText: 'name@company.com',
    buttonSendText: i18n('Get started for free'),
    errorList: {
        errorRequired: i18n('Please enter your email.'),
        errorFormat: i18n('Please enter a valid email.'),
        errorLimit: i18n('The email is too long.'),
        error404: i18n("The server isn't responding. Please try again later."),
        error429: i18n('You have exceeded the limit of requests. Please try again in 1 hour.'),
        errorServerCommon: i18n('Unexpected server error. Please try again later.'),
        errorBusinessEmail: i18n('Please enter your business email'),
        errorNoNetworkConnection: i18n('No internet connection'),
        errorGoogleBusinessEmail: i18n('Please use a business email address to register with Google'),
    },
    googleButtonText: {
        business: i18n('or use Google business account'),
        nonBusiness: i18n('or use Google account'),
    },
});
